import React, { useEffect, useState } from "react";
import { LandingPage } from "./pages/LandingPage";
const GA_ID = "G-KQKQ10E4Z3";

// ====================================
// H·E·R Journey Indicator
// Desktop only — fixed left sidebar
// Se activa por scroll: 0-33% H, 33-66% E, 66-100% R
// ====================================
function HERIndicator() {
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const progress = window.scrollY / Math.max(1, document.body.scrollHeight - window.innerHeight);
      if (progress < 0.33) setPhase(0);else if (progress < 0.66) setPhase(1);else setPhase(2);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const node = (letter: string, idx: number) => <div key={letter} className={`w-7 h-7 rounded-full border flex items-center justify-center text-[11px] font-bold transition-all duration-500
        ${idx <= phase ? 'border-[#C8A870] text-[#C8A870] bg-[rgba(200,168,112,0.08)]' : 'border-white/10 text-white/20'}`} style={{
    fontFamily: 'sans-serif',
    letterSpacing: '0.04em'
  }} data-id="element-0" data-mp="28t4lsf4bmctj">
      {letter}
    </div>;
  const line = (idx: number) => <div key={`l${idx}`} className={`w-px transition-all duration-700 ${idx < phase ? 'bg-[#C8A870]' : 'bg-white/8'}`} style={{
    height: 32
  }} data-id="element-1" data-mp="3rdki07xp0nov" />;
  return <div className="hidden md:flex fixed left-5 top-1/2 -translate-y-1/2 z-40 flex-col items-center" data-id="element-2" data-mp="2zl3cjn8vpa6d">
      {node('H', 0)}
      {line(0)}
      {node('E', 1)}
      {line(1)}
      {node('R', 2)}
      <p className="mt-3 text-[9px] text-[#C8A870] tracking-[0.18em] transition-opacity duration-700" style={{
      fontFamily: 'sans-serif',
      writingMode: 'vertical-rl',
      opacity: phase >= 2 ? 1 : 0
    }} data-id="element-3" data-mp="38lrpeemjd4ho">
        lista
      </p>
    </div>;
}
export function App() {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
    const inlineScript = document.createElement("script");
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_ID}');
    `;
    document.head.appendChild(inlineScript);
    const utmParams = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
    const searchParams = new URLSearchParams(window.location.search);
    const hasUtms = utmParams.some(utm => searchParams.get(utm));
    if (hasUtms) {
      const transferUtms = () => {
        document.querySelectorAll<HTMLAnchorElement>('a[href*="simpleymejor.com"]').forEach(link => {
          const url = new URL(link.href);
          utmParams.forEach(utm => {
            const value = searchParams.get(utm);
            if (value) url.searchParams.set(utm, value);
          });
          link.href = url.toString();
        });
      };
      transferUtms();
      setTimeout(transferUtms, 1000);
    }
    if (!sessionStorage.getItem("view_content_sent")) {
      sessionStorage.setItem("view_content_sent", "1");
      const getCookie = (name: string) => {
        const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
        return match ? decodeURIComponent(match[2]) : undefined;
      };
      const generateEventId = (prefix: string) => `${prefix}-${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;
      setTimeout(async () => {
        const fbp = getCookie("_fbp");
        const fbc = getCookie("_fbc");
        const eventId = generateEventId("VC");
        if (typeof window !== "undefined" && (window as any).fbq) {
          (window as any).fbq("track", "ViewContent", {
            currency: "ARS",
            value: 12000
          }, {
            eventID: eventId
          });
        }
        const payload = {
          event_id: eventId,
          fbp,
          fbc,
          currency: "ARS",
          value: 12000
        };
        try {
          await fetch("https://mercadopago-her-backend.vercel.app/api/view-content", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
          });
        } catch {}
      }, 1000);
    }
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(inlineScript);
    };
  }, []);
  return <>
      <HERIndicator data-id="element-4" data-mp="14xyagi0z7hd2" />

      <LandingPage data-id="element-5" data-mp="14xpz4uki4k3z" />

      
    </>;
}